import { useState } from 'react';

import Icon, { IconName } from '@/components/Icon/Icon';

import useStyles from './QuantityPicker.style';

export default function QuantityPicker({
  min = 1,
  max = 99,
  initialValue = 1,
  onChange,
}: {
  min?: number;
  max?: number;
  initialValue: number;
  onChange: (num: number) => void;
}) {
  const { classes } = useStyles();
  const [quantity, setQuantity] = useState(initialValue);

  const handleIncrement = () => {
    onChange?.(quantity + 1);
    setQuantity((prevQuantity) => Math.min(prevQuantity + 1, max));
  };

  const handleDecrement = () => {
    onChange?.(quantity - 1);
    setQuantity((prevQuantity) => Math.max(prevQuantity - 1, min));
  };

  return (
    // biome-ignore lint/a11y/useSemanticElements: Automated migration to Biome
    <div
      role='group'
      aria-label='Quantity selector'
      className={classes.container}
    >
      <button
        type='button'
        onClick={handleDecrement}
        disabled={quantity <= min}
        aria-label='Decrease quantity'
        className={classes.button}
      >
        <Icon name={IconName.SUBTRACT} width={16} />
      </button>
      <div
        role='spinbutton'
        aria-valuemin={min}
        aria-valuemax={max}
        aria-valuenow={quantity}
        aria-label='Selected quantity'
        className={classes.quantityBox}
      >
        {quantity}
      </div>
      <button
        type='button'
        onClick={handleIncrement}
        disabled={quantity >= max}
        aria-label='Increase quantity'
        className={classes.button}
      >
        <Icon name={IconName.ADD} width={16} />
      </button>
    </div>
  );
}
